import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './index'

export function AppRouter(): React.JSX.Element {
    return <RouterProvider router={router} />
}
